import {
  Component,
  Input,
  ElementRef,
  OnInit,
  OnChanges,
  ViewEncapsulation
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Component({
  selector: 'inline-svg',
  template: '',
  encapsulation: ViewEncapsulation.None
})
export class InlineSvgComponent implements OnInit, OnChanges {
  @Input() src!: string;
  @Input() color?: string;
  @Input() hoverColor?: string;
  @Input() activeColor?: string;
  @Input() className?: string;
  @Input() parentClass?: string;

  private static svgCache = new Map<string, string>();
  private static requestCache = new Map<string, Observable<string>>();

  constructor(private http: HttpClient, private el: ElementRef) {}

  ngOnInit(): void {
    this.loadSvg();
  }

  ngOnChanges(): void {
    this.loadSvg();
  }

  private loadSvg(): void {
    if (!this.src) return;

    const fullPath = `assets/icons/${  this.src}`;
    const container = this.el.nativeElement;

    const render = (svg: string) => {
      Object.assign(container.style, {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      });

      container.innerHTML = svg;

      const svgEl = container.querySelector('svg');
      if (svgEl) {
        if (!svgEl.hasAttribute('viewBox')) {
          const width = svgEl.getAttribute('width');
          const height = svgEl.getAttribute('height');
          if (width && height) {
            svgEl.setAttribute('viewBox', `0 0 ${width} ${height}`);
          }
        }
        const allElements = svgEl.querySelectorAll('[fill]');
        allElements.forEach(el => {
          const fill = el.getAttribute('fill');
          if (fill.includes('F7F9F9')) return;
          el.setAttribute('fill', 'currentColor');
        });

        if (this.className) svgEl.classList.add(this.className);

        const className = `svg-style-${Math.random().toString(36).substring(2, 9)}`;
        svgEl.classList.add(className);

        const style = document.createElement('style');
        const selector = this.parentClass ? `.${this.parentClass}` : `.${className}`;

        style.innerHTML = `
          .${className} {
            color: ${this.color || 'inherit'};
            transition: color 0.3s ease;
          }
        
          ${selector}:hover .${className}, .${className}:hover {
            color: ${this.hoverColor || this.color || 'inherit'};
          }
        
          ${selector}:active .${className}, .${className}:active {
            color: ${this.activeColor || this.hoverColor || this.color || 'inherit'};
          }
        `;
        container.appendChild(style);
      }
    };

    if (InlineSvgComponent.svgCache.has(fullPath)) {
      render(InlineSvgComponent.svgCache.get(fullPath)!);
      return;
    }

    if (InlineSvgComponent.requestCache.has(fullPath)) {
      InlineSvgComponent.requestCache.get(fullPath)!.subscribe(render);
      return;
    }

    const request$ = this.http.get(fullPath, { responseType: 'text' }).pipe(shareReplay(1));
    InlineSvgComponent.requestCache.set(fullPath, request$);

    request$.subscribe(svg => {
      InlineSvgComponent.svgCache.set(fullPath, svg);
      render(svg);
    });
  }
}
